import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import {ProductserviceFileupload} from "../services/productserviceFileupload.service";
import {Productservice} from "../services/productservice.service";
import {Router} from '@angular/router';
import {Location} from "@angular/common";
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { LocalStorageService } from 'angular-web-storage';




@Component({
  selector: 'productAdd',
  templateUrl: './productAdd.component.html',
  styleUrls: ['../app.component.css']
})
export class ProductAdd implements OnInit {
  

  dataForm: FormGroup;
  haserror = false;
  errors: string[];
      submittedDataForm = false;

  public Editor = ClassicEditor;
  public editorConfig = {
        fontFamily: {
          options: [
            'default',
            'Ubuntu, Arial, sans-serif',
            'Ubuntu Mono, Courier New, Courier, monospace'
          ]
        },
        toolbar: [
          'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' 
        ]
   };


  

  constructor(private fb: FormBuilder, 
    private productserviceFileupload: ProductserviceFileupload,
    private productservice: Productservice,
    private location: Location,

    private router: Router,private local: LocalStorageService) { }

  ngOnInit() {

    this.dataForm = this.fb.group({
      productTitle: [,Validators.required], category: [,Validators.required], productImage: [,Validators.required], productImageAlt: [], productPriceRange: [,Validators.required], productShortDescription: [,Validators.required], productLongDescription: [,Validators.required], productAltImageName1: [], productAltImage1: [], productAltImageAlt1: [], productAltImageName2: [], productAltImage2: [], productAltImageAlt2: [], productAltImageName3: [], productAltImage3: [], productAltImageAlt3: [], productAltImageName4: [], productAltImage4: [], productAltImageAlt4: [], showOnHomePage: [1,Validators.required], status: [1,Validators.required],
    });

  } 
  goBack(): void {
    this.location.back();
  }
   


  onSelectedproductImage(event) {
							    if (event.target.files.length> 0) {
							      const productImage = event.target.files[0];
							      this.dataForm.get('productImage').setValue(productImage);
							    }
							  }onSelectedproductAltImage1(event) {
							    if (event.target.files.length> 0) {
							      const productAltImage1 = event.target.files[0];
							      this.dataForm.get('productAltImage1').setValue(productAltImage1);
							    }
							  }onSelectedproductAltImage2(event) {
							    if (event.target.files.length> 0) {
							      const productAltImage2 = event.target.files[0];
							      this.dataForm.get('productAltImage2').setValue(productAltImage2);
							    }
							  }onSelectedproductAltImage3(event) {
							    if (event.target.files.length> 0) {
							      const productAltImage3 = event.target.files[0];
							      this.dataForm.get('productAltImage3').setValue(productAltImage3);
							    }
							  }onSelectedproductAltImage4(event) {
							    if (event.target.files.length> 0) {
							      const productAltImage4 = event.target.files[0];
							      this.dataForm.get('productAltImage4').setValue(productAltImage4);
							    }
							  }
  get validate() { return this.dataForm.controls; }

  onSubmit() {
    
   this.submittedDataForm = true;

    // stop here if form is invalid
    if (this.dataForm.invalid) {
        return;
    }
    const formData = new FormData();
				    let product={"assetName":this.dataForm.get('productTitle').value,"assetParentId":"0","assetPropertyList":[{"assetTypePropertyName":"productTitle","assetPropertyValue":this.dataForm.get('productTitle').value},{"assetTypePropertyName":"category","assetPropertyValue":this.dataForm.get('category').value},{"assetTypePropertyName":"productImage","assetPropertyValue":"IGNORE"},{"assetTypePropertyName":"productImageAlt","assetPropertyValue":this.dataForm.get('productImageAlt').value},{"assetTypePropertyName":"productPriceRange","assetPropertyValue":this.dataForm.get('productPriceRange').value},{"assetTypePropertyName":"productShortDescription","assetPropertyValue":this.dataForm.get('productShortDescription').value},{"assetTypePropertyName":"productLongDescription","assetPropertyValue":this.dataForm.get('productLongDescription').value},{"assetTypePropertyName":"productAltImageName1","assetPropertyValue":this.dataForm.get('productAltImageName1').value},{"assetTypePropertyName":"productAltImage1","assetPropertyValue":"IGNORE"},{"assetTypePropertyName":"productAltImageAlt1","assetPropertyValue":this.dataForm.get('productAltImageAlt1').value},{"assetTypePropertyName":"productAltImageName2","assetPropertyValue":this.dataForm.get('productAltImageName2').value},{"assetTypePropertyName":"productAltImage2","assetPropertyValue":"IGNORE"},{"assetTypePropertyName":"productAltImageAlt2","assetPropertyValue":this.dataForm.get('productAltImageAlt2').value},{"assetTypePropertyName":"productAltImageName3","assetPropertyValue":this.dataForm.get('productAltImageName3').value},{"assetTypePropertyName":"productAltImage3","assetPropertyValue":"IGNORE"},{"assetTypePropertyName":"productAltImageAlt3","assetPropertyValue":this.dataForm.get('productAltImageAlt3').value},{"assetTypePropertyName":"productAltImageName4","assetPropertyValue":this.dataForm.get('productAltImageName4').value},{"assetTypePropertyName":"productAltImage4","assetPropertyValue":"IGNORE"},{"assetTypePropertyName":"productAltImageAlt4","assetPropertyValue":this.dataForm.get('productAltImageAlt4').value},{"assetTypePropertyName":"showOnHomePage","assetPropertyValue":this.dataForm.get('showOnHomePage').value},{"assetTypePropertyName":"status","assetPropertyValue":this.dataForm.get('status').value}],"assetTypeId":this.local.get("product")};  


				   	var thisobj = this;

		            this.productservice.add(product)
		            .then(productdata => {
		              let response = JSON.parse(JSON.stringify(productdata));


			        if (response.status == false) {
                      this.errors.push(response.message);
                    }
                    else {
				   
				    	let assetPropertyNames = '';

				    


    								if (thisobj.dataForm.get('productImage').value!='' && thisobj.dataForm.get('productImage').value!=null) {
    									assetPropertyNames+='assetPropertyNames=productImage&';
    									formData.append('files', thisobj.dataForm.get('productImage').value);
    								}
							


    								if (thisobj.dataForm.get('productAltImage1').value!='' && thisobj.dataForm.get('productAltImage1').value!=null) {
    									assetPropertyNames+='assetPropertyNames=productAltImage1&';
    									formData.append('files', thisobj.dataForm.get('productAltImage1').value);
    								}
							


    								if (thisobj.dataForm.get('productAltImage2').value!='' && thisobj.dataForm.get('productAltImage2').value!=null) {
    									assetPropertyNames+='assetPropertyNames=productAltImage2&';
    									formData.append('files', thisobj.dataForm.get('productAltImage2').value);
    								}
							


    								if (thisobj.dataForm.get('productAltImage3').value!='' && thisobj.dataForm.get('productAltImage3').value!=null) {
    									assetPropertyNames+='assetPropertyNames=productAltImage3&';
    									formData.append('files', thisobj.dataForm.get('productAltImage3').value);
    								}
							


    								if (thisobj.dataForm.get('productAltImage4').value!='' && thisobj.dataForm.get('productAltImage4').value!=null) {
    									assetPropertyNames+='assetPropertyNames=productAltImage4&';
    									formData.append('files', thisobj.dataForm.get('productAltImage4').value);
    								}
							

		            let productattr ='assetId=' + response.response + '&' + assetPropertyNames;

		            if (assetPropertyNames!='') {

					    this.productserviceFileupload.add(productattr ,formData ).then(model =>{
					   
						    if (model!=undefined) {	
		    	                let response = JSON.parse(JSON.stringify(model));

						        if (response.status==true) {
							    		 this.router.navigate(['/product']);
						          	
						        }
						    }
					    });
					}
                }
            });
    

  }

}